export const faerunCalendar = {
  name: 'Harptos',
  months: [
    {
      name: 'Hammer',
      days: 30,
      leapDays: 1,
      leapPeriod: 1,
    },
    {
      name: 'Midwinter',
      days: 1,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Alturiak',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Ches',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Tarsakh',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Greengrass',
      days: 1,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Mirtul',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Kythorn',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Flamerule',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Midsummer',
      days: 1,
      leapDays: 1,
      leapPeriod: 4,
    },
    {
      name: 'Eleasis',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Eleint',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Highharvestide',
      days: 1,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Marpenoth',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Uktar',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Feast of the Moon',
      days: 1,
      leapDays: 0,
      leapPeriod: 0,
    },
    {
      name: 'Mightal',
      days: 30,
      leapDays: 0,
      leapPeriod: 0,
    },
  ],
  time: {
    minute: {
      name: 'Minute',
      plural: 'Minutes',
      duration: '60',
    },
    hour: {
      name: 'Hour',
      plural: 'Hours',
      duration: '3600',
    },
    day: {
      name: 'Day',
      plural: 'Days',
      duration: '86400',
    },
    month: {
      name: 'Month',
      plural: 'Months',
    },
    year: {
      name: 'Year',
      plural: 'Years',
      duration: '31536000',
    },
    decade: {
      name: 'Decade',
      plural: 'Decades',
      enabled: true,
      duration: '315360000',
    },
    century: {
      name: 'Century',
      plural: 'Centuries',
      enabled: true,
      duration: '3153600000',
    },
    millenium: {
      name: 'Millenium',
      plural: 'Millenia',
      enabled: true,
      duration: '31536000000',
    },
    myriad: {
      name: 'Myriad',
      plural: 'Myriads',
      enabled: true,
      duration: '315360000000',
    },
    epoch: {
      name: 'Epoch',
      plural: 'Epochs',
      enabled: true,
      duration: '31536000000000',
    },
    aeon: {
      name: 'Aeon',
      plural: 'Aeons',
      enabled: true,
      duration: '31536000000000000',
    },
  },
  days: {
    showWeekdays: false,
    weekLength: 10,
    weekdays: [],
    globalHolidays: [{ name: 'Shieldmeet', day: 2, month: 9 }],
  },
};
